import SocialLinks from "./social-links";
import * as Query from "../static data/queryparams";
import { useLocation, useNavigate } from "react-router-dom";
import {menuitems} from "../static data/menu-items"
import { useState } from "react";
import ContactUs from "./contact-us";
import * as links from '../static data/sociallinks'
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function Footer(){
    const location = useLocation();
    const [modalOpened,setModalOpened] = useState(false);
    const navigate = useNavigate();  
    
    const { t, i18n } = useTranslation();
    function goToPage(link, type){
         navigate({
             pathname: "/apartments-search",
             search: Query.property + "=" + link +"&" + Query.offertype + "=" + type
         });
         if(location.pathname=="/apartments-search")navigate(0);
     }

     function CloseModal(){
        setModalOpened(false);
     }

     function goToServices(){       
        setModalOpened(true);
        return;
        navigate({
            pathname: "/main",
            hash: "#services"
        });
        if(location.pathname=="/main")navigate(0);
    }    
    const handleChangeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return(
        <>
            {modalOpened ? <ContactUs closeModal = {CloseModal}/> : ""}
            {/* <div className="footer">                
                <div id="block">
                    <div id="title">{t('Acheter')}</div>
                    <div id="contacts">
                    {menuitems[1].submenu.map(x=>
                                        <>
                                            <div className="link-item" onClick={()=>goToPage(x.link,menuitems[1].type)}>
                                                {x.name}
                                            </div>
                                        </>
                                    )}
                    </div>
                </div>
                <div id="block">
                    <div id="title">{t('Louer')}</div>
                    <div id="contacts">
                    {menuitems[2].submenu.map(x=>
                                        <>
                                            <div className="link-item" onClick={()=>goToPage(x.link,menuitems[2].type)}>
                                                {x.name}
                                            </div>
                                        </>
                                    )}
                    </div>
                </div>
                <div id="block">
                    <div id="title">{t('Nos Services')}</div>
                    <div id="contacts" >
                        <div onClick={goToServices}  className="clickable">{t('Topographie')}</div>
                        <div onClick={goToServices}  className="clickable">{t('Construire')}</div>
                    </div>
                </div>
                <div id="block">
                    <div id="contacts">
                        <div>{t('Email :')}<a href="mailto:info@lmplatinumestates.cm">info@lmplatinumestates.cm</a><br/>
                        </div>
                        <div> 
                            Appels / WhatsApp : <a href="tel:+237 692 85 05 84">+237 692 85 05 84</a><br/>
                        </div>
                        <div> 
                        Appels : <a href="tel:+237 651 12 50 90">+237 651 12 50 90</a> / <a href="tel:+237 658 91 74 77">+237 658 91 74 77</a><br/>
                        </div>
                    </div>
                </div>
            </div>
            
            <div id="social-footer-icons">
                    <SocialLinks/>
            </div> */}

            <div id='footer'>
                {!isMobile ?
                <div id = 'logo'>
                    <img src='new_logo.svg'/>
                </div>
                :""}
                <div id = 'lists'>
                    {/* <div id="language-select-container">
                        <label htmlFor="language-select">{t('Language')}: </label>
                        <select id="language-select" value={i18n.language} onChange={handleChangeLanguage}>
                            <option value="fr">French</option>
                            <option value="en">{t('English')}</option>
                        </select>
                    </div> */}
                    <div>
                        <div id='title'>{t('Acheter')}</div>
                        <hr/>
                        <div id='list'>
                            {menuitems[1].submenu.map(x=>
                                            <>
                                                <div className="link-item" onClick={()=>goToPage(x.link,menuitems[1].type)}>
                                                    {t(x.name)}
                                                </div>
                                            </>
                                        )}
                        </div>
                    </div>
                    <div>
                        <div id='title'>{t('Louer')}</div>
                        <hr/>
                        <div id='list'>
                            {menuitems[2].submenu.map(x=>
                                            <>
                                                <div className="link-item" onClick={()=>goToPage(x.link,menuitems[2].type)}>
                                                    {t(x.name)}
                                                </div>
                                            </>
                                        )}
                        </div>
                    </div>
                    <div>
                        <div id='title'>{t('Nos Services')}</div>
                        <hr/>
                        <div id='list'>
                            <div onClick={goToServices} >{t('Topographie')}</div>
                            <div onClick={goToServices}>{t('Construire')}</div>
                        </div>
                    </div>
                    <div>
                        <div id='title'>Contactez-nous</div>
                        <hr/>
                        <div id='list'>
                            <div>{t('Email :')}<a href="mailto:info@lmplatinumestates.cm"> info@lmplatinumestates.cm</a><br/>
                            </div>
                            <div> 
                                Appels / WhatsApp : <a href="tel:+237 692 85 05 84"> +237 692 85 05 84</a><br/>
                            </div>
                            <div> 
                            Appels : <a href="tel:+237 651 12 50 90"> +237 651 12 50 90</a> / <a href="tel:+237 658 91 74 77">+237 658 91 74 77</a><br/>
                            </div>
                        </div>
                    </div>
                </div>
                <div id = 'social'>
                    <a href={links.links[1].link} target="_blank">
                        <img src='instablue.svg'/>
                    </a>
                    <a href={links.links[2].link} target="_blank">
                    <img src='facebookblue.svg'/></a>
                    <a href={links.links[4].link} target="_blank">
                    <img src='tiktokblue.svg'/></a>
                </div>
            </div>
        </>
    )
}